import { useQuery } from "react-query";
import { getDescriptionsRole } from "~/pages/RegistryOfRole/rolesRequest/getDescriptionsRole";

export default function useGetDescriptionsRole() {
  return useQuery({
    queryKey: ["getDescriptionsRole"],
    queryFn: () => getDescriptionsRole(),
    refetchOnWindowFocus: false,
    // enabled,
    cacheTime: 0,
  });
}
